import { createAction } from '@reduxjs/toolkit'

export const submitConfiguration = createAction('Submit configuration')
